import type { ChatSettings } from '../types';

export const defaults: Partial<ChatSettings> = {
  bubbleIcon: {
    url: 'https://static.elfsight.com/icons/app-chats-viber.svg'
  },
  buttonText: 'Chat on Viber',
  welcomeMessage: 'Hi there 👋 <br><br>How can I help you?',
  bubbleBackgroundColor: 'rgb(255, 255, 255)',
  bubbleIconColor: 'rgb(104, 90, 176)',
  headerBackgroundColor: 'rgb(97, 72, 196)',
  messageBackgroundColor: 'rgb(238, 245, 250)',
  buttonColor: { type: 'native', color: 'rgb(102, 184, 33)' },
  buttonBorderRadius: 16,
  align: 'right'
};
